
import Vue from 'vue'

const getDefaultState = () => {
    return {
        purcharorder: {
            id: 0,
            idVendor: 0,
            idClass: "",
            idTemplate: ""
        }
    }
};

const state = getDefaultState();

const actions = {

    resetState({ commit }) {
        commit('resetState');
    },

    saveState({ commit }, payload) {
        commit('saveState', payload);
    },

    async List() {

        try {
            const result = await Vue.prototype.$vanKirkApi.get("quickbooks/purcharorder/list",
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                const listPurchaseOrder = result.data.result;

                return listPurchaseOrder;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list purchase order: [${ex}]`
            };
        }
    },

    async ListItems(_, id) {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`quickbooks/purcharorder/list-items/${id}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                const listItems = result.data.result;

                return listItems;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list purchase order items: [${ex}]`
            };
        }
    },

    async ListHistory(_, id) {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`quickbooks/purcharorder/list-history/${id}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                const ListHistory = result.data.result;

                return ListHistory;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list purchase order history: [${ex}]`
            };
        }
    },

    async GetById(_, id) {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`quickbooks/purcharorder/${id}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {
                return result.data;
            }
            else {
                return {
                    success: false,
                    result: `Error to get customer`
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                result: `Error to get customer: [${ex}]`
            };
        }
    },

    async CreateUpdate(_, purchaseOrderRequest) {

        try {

            const result = await Vue.prototype.$vanKirkApi.post(`quickbooks/purcharorder/create-update`, purchaseOrderRequest,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 204) {

                let msg = "Register updated with success!";

                if (purchaseOrderRequest.id === 0) {
                    msg = "Record created successfully";
                }

                return {
                    success: true,
                    message: msg
                };
            }
            else {
                return {
                    success: false,
                    message: "Error to create/update register!"
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `Error to create/update register: [${error.response.data}]`
                };
            }
            else {

                return {
                    success: false,
                    message: `Error to create/update register: [${error}]`
                };
            }
        }
    },

    async UpdateStatus(_, { id, statusId }) {

        try {
            const result = await Vue.prototype.$vanKirkApi.put(`quickbooks/purcharorder/update-status/${id}/${statusId}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 204) {
                return {
                    success: true,
                    message: "Status updated with success!"
                };
            }
            else {
                return {
                    success: false,
                    message: "Error updating the status!"
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error updating the status: [${ex}]`
            };
        }
    },

    async CreateByListOrders(_, purchaseOrderRequest) {

        try {

            const result = await Vue.prototype.$vanKirkApi.post(`quickbooks/purcharorder/create-by-list-orders`, purchaseOrderRequest,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 204) {

                return {
                    success: true,
                    message: "Record created successfully"
                };
            }
            else {
                return {
                    success: false,
                    message: "Error to create/update register!"
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `Error to create/update register: [${error.response.data}]`
                };
            }
            else {

                return {
                    success: false,
                    message: `Error to create/update register: [${error}]`
                };
            }
        }
    },
}

const mutations = {

    saveState: (state, newValue) => {
        Object.assign(state.purcharorder, newValue);
    },

    resetState: (state) => {
        Object.assign(state, getDefaultState());
    }
}

const getters = {

    searchState: (state) => {
        return state.purcharorder;
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
